import {
  Button,
  ExportButton,
  FilterButton,
  SelectColumnsButton,
  TopToolbar,
  usePermissions,
} from "react-admin";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import MyCreateButton from "../common/MyCreateButton";

const TableListActionsWithUpload = ({
  createHandler,
  exporter,
  uploadHandler,
  createPermission,
  extraActions = null,
  showColumns = true,
  showFilters = true,
}) => {
  const { permissions } = usePermissions();
  return (
    <TopToolbar
      sx={{
        minHeight: "54px !important",
        mb: 1,
        "& .MuiButtonBase-root": {
          border: "0.1rem solid",
        },
      }}
    >
      {showColumns ? <SelectColumnsButton /> : null}
      {showFilters ? <FilterButton /> : null}
      {extraActions}
      {(permissions.administrator || permissions[createPermission]) &&
      createHandler ? (
        <MyCreateButton
          // startIcon={<AddIcon />}
          label="ra.action.create"
          // sx={{ width: "fit-content" }}
          onClick={createHandler}
        />
      ) : null}
      {exporter === false ? null : <ExportButton />}
      {uploadHandler ? (
        <Button
          label="mine.label.upload"
          sx={{ width: "fit-content" }}
          onClick={uploadHandler}
        >
          <UploadFileIcon />
        </Button>
      ) : null}
    </TopToolbar>
  );
};

export default TableListActionsWithUpload;
